import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

function getUrl() {
  return `v1/stock-pnl/realized/monthly`;
}

/**
 * @typedef {import('./typedefs').PnlMonthlyResponse}  PnlMonthlyResponse
 * @typedef {import('@helpers/fetcher').FetchResponse<PnlMonthlyResponse>} Response
 */

/**
 * @param {string} url
 * @param {import('./typedefs').AccountType} accountType
 * @returns
 */
function callbackFetch(url, accountType, size) {
  return async ({ pageParam = 1 }) => {
    try {
      /** @type {Response} */
      const res = await fetcher.get(url, {
        params: { type: accountType, page: pageParam, page_size: size },
      });

      return res.data;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

/**
 * @param {import('./typedefs').AccountType} accountType
 * @param {number} size
 */
export default function fetch(accountType, size) {
  const url = getUrl();
  const cb = callbackFetch(url, accountType, size);
  const key = [url, accountType];

  return { cb, key };
}
